import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 565.692 341.058"
    {...props}
  >
    <defs>
      <style>
        {
          ".dedicated-support-1{fill:#fff}.dedicated-support-2{fill:#e9ecef}.dedicated-support-3{fill:#00aeef}.dedicated-support-4{opacity:.3}.dedicated-support-5{fill:none;stroke:#e9ecef;stroke-miterlimit:10}.dedicated-support-6{fill:#c1c6cb}.dedicated-support-7{fill:#00bcd4}.dedicated-support-8{fill:#1eca8a}"
        }
      </style>
    </defs>
    <g id="Guides_and_Back" data-name="Guides and Back">
      <path
        d="M566.119 297.519c-33.653 38.721-88.67 8.47-228.054 13.683C156.272 318 106.458 374.827 60.491 337.265c-75.776-61.919-33.344-292.29 61.249-325.139 26.127-9.074 40.572 2.361 102.3 20.2 183.841 53.126 247.138 7.011 308.2 63.855 56.351 52.461 72.469 156.935 33.879 201.338Z"
        transform="translate(-21.526 -8.942)"
      />
      <path className="dedicated-support-1" d="M28.474 41.058h500v250h-500z" />
    </g>
    <g id="Page_Content" data-name="Page Content">
      <path
        className="dedicated-support-1"
        d="M64.69 59.558h138.156a3.716 3.716 0 0 1 3.716 3.716v17.032a3.715 3.715 0 0 1-3.715 3.715H64.689a3.715 3.715 0 0 1-3.715-3.715V63.274a3.716 3.716 0 0 1 3.716-3.716Z"
      />
      <path
        className="dedicated-support-2"
        d="M224.373 69a3.22 3.22 0 0 1 3.216 3.216v17.031a3.22 3.22 0 0 1-3.216 3.216H86.216A3.219 3.219 0 0 1 83 89.247V72.216A3.219 3.219 0 0 1 86.216 69h138.157m0-1H86.216A4.228 4.228 0 0 0 82 72.216v17.031a4.228 4.228 0 0 0 4.216 4.216h138.157a4.228 4.228 0 0 0 4.216-4.216V72.216A4.228 4.228 0 0 0 224.373 68Z"
        transform="translate(-21.526 -8.942)"
      />
      <path
        className="dedicated-support-3"
        d="M224.589 93.463h-20.432V68h20.432a4.012 4.012 0 0 1 4 4v17.463a4.012 4.012 0 0 1-4 4Z"
        transform="translate(-21.526 -8.942)"
      />
      <rect
        className="dedicated-support-3"
        x={217.535}
        y={59.058}
        width={32.237}
        height={25.463}
        rx={4}
      />
      <g className="dedicated-support-4">
        <rect
          className="dedicated-support-3"
          x={60.474}
          y={99.074}
          width={65.097}
          height={19.386}
          rx={4.96}
        />
      </g>
      <rect
        className="dedicated-support-3"
        x={64.482}
        y={103.486}
        width={11.569}
        height={10.561}
        rx={1.543}
      />
      <g className="dedicated-support-4">
        <rect
          className="dedicated-support-3"
          x={131.591}
          y={99.074}
          width={65.097}
          height={19.386}
          rx={4.96}
        />
      </g>
      <rect
        className="dedicated-support-3"
        x={135.599}
        y={103.486}
        width={11.569}
        height={10.561}
        rx={1.543}
      />
      <g className="dedicated-support-4">
        <rect
          className="dedicated-support-3"
          x={202.708}
          y={99.074}
          width={65.097}
          height={19.386}
          rx={4.96}
        />
      </g>
      <rect
        className="dedicated-support-3"
        x={206.716}
        y={103.486}
        width={11.569}
        height={10.561}
        rx={1.543}
      />
      <g className="dedicated-support-4">
        <rect
          className="dedicated-support-3"
          x={273.825}
          y={99.074}
          width={65.097}
          height={19.386}
          rx={4.96}
        />
      </g>
      <rect
        className="dedicated-support-3"
        x={277.833}
        y={103.486}
        width={11.569}
        height={10.561}
        rx={1.543}
      />
      <g className="dedicated-support-4">
        <rect
          className="dedicated-support-3"
          x={344.942}
          y={99.074}
          width={65.097}
          height={19.386}
          rx={4.96}
        />
      </g>
      <rect
        className="dedicated-support-3"
        x={348.95}
        y={103.486}
        width={11.569}
        height={10.561}
        rx={1.543}
      />
      <g className="dedicated-support-4">
        <rect
          className="dedicated-support-3"
          x={416.059}
          y={99.074}
          width={65.097}
          height={19.386}
          rx={4.96}
        />
      </g>
      <rect
        className="dedicated-support-3"
        x={420.067}
        y={103.486}
        width={11.569}
        height={10.561}
        rx={1.543}
      />
      <g className="dedicated-support-4">
        <rect
          className="dedicated-support-3"
          x={60.474}
          y={125.902}
          width={65.097}
          height={19.386}
          rx={4.96}
        />
      </g>
      <rect
        className="dedicated-support-3"
        x={64.482}
        y={130.314}
        width={11.569}
        height={10.561}
        rx={1.543}
      />
      <rect
        className="dedicated-support-3"
        x={260.245}
        y={59.058}
        width={53.103}
        height={25.463}
        rx={4}
      />
      <rect
        className="dedicated-support-1"
        x={362.457}
        y={59.558}
        width={133.517}
        height={24.463}
        rx={3.5}
      />
      <path
        className="dedicated-support-2"
        d="M514 69a3 3 0 0 1 3 3v17.463a3 3 0 0 1-3 3H387.484a3 3 0 0 1-3-3V72a3 3 0 0 1 3-3H514m0-1H387.484a4.012 4.012 0 0 0-4 4v17.463a4.012 4.012 0 0 0 4 4H514a4.012 4.012 0 0 0 4-4V72a4.012 4.012 0 0 0-4-4Z"
        transform="translate(-21.526 -8.942)"
      />
      <path
        className="dedicated-support-5"
        d="M385.225 59.058v24.828M407.04 59.058v24.828M428.855 59.058v24.828M450.67 59.058v24.828M472.485 59.058v24.828"
      />
      <rect
        className="dedicated-support-1"
        x={60.974}
        y={157.91}
        width={435}
        height={114.648}
        rx={3.5}
      />
      <path
        className="dedicated-support-2"
        d="M514 167.352a3 3 0 0 1 3 3V278a3 3 0 0 1-3 3H86a3 3 0 0 1-3-3V170.352a3 3 0 0 1 3-3h428m0-1H86a4.012 4.012 0 0 0-4 4V278a4.012 4.012 0 0 0 4 4h428a4.012 4.012 0 0 0 4-4V170.352a4.012 4.012 0 0 0-4-4Z"
        transform="translate(-21.526 -8.942)"
      />
      <path
        className="dedicated-support-5"
        d="M78.723 157.41v115.648M60.474 177.966h436M60.474 215.234h436M60.474 252.503h436M278.474 157.41v115.648M351.848 157.41v115.648M429.216 157.41v115.648"
      />
      <path
        className="dedicated-support-6"
        d="M66.507 163.775h8.29v8.64h-8.29zM66.507 192.28h8.29v8.64h-8.29zM66.507 229.549h8.29v8.64h-8.29zM66.507 265.728h8.29v6.082h-8.29zM294.966 163.775h39.724v8.64h-39.724zM288.814 192.28h52.694v8.64h-52.694zM377.49 163.775h27.946v8.64H377.49zM377.49 200.19h27.946v8.64H377.49zM442.281 163.775h37.666v8.64h-37.666zM110.823 163.775h135.552v8.64H110.823zM85.299 185.147h151.427v8.64H85.299z"
      />
      <path className="dedicated-support-7" d="M85.299 200.19h75.714v8.64H85.299z" />
      <ellipse
        className="dedicated-support-8"
        cx={391.464}
        cy={192.234}
        rx={5.317}
        ry={5.268}
      />
      <ellipse
        className="dedicated-support-6"
        cx={461.114}
        cy={193.161}
        rx={1.363}
        ry={1.421}
      />
      <ellipse
        className="dedicated-support-6"
        cx={461.114}
        cy={197.708}
        rx={1.363}
        ry={1.421}
      />
      <ellipse
        className="dedicated-support-6"
        cx={461.114}
        cy={202.255}
        rx={1.363}
        ry={1.421}
      />
      <path
        className="dedicated-support-6"
        d="M286.321 229.16h57.014v8.64h-57.014zM377.49 237.071h27.946v8.64H377.49zM85.299 222.027h137.84v8.64H85.299z"
      />
      <path className="dedicated-support-7" d="M85.299 237.071h75.714v8.64H85.299z" />
      <ellipse
        className="dedicated-support-8"
        cx={391.464}
        cy={229.114}
        rx={5.317}
        ry={5.268}
      />
      <ellipse
        className="dedicated-support-6"
        cx={461.114}
        cy={230.041}
        rx={1.363}
        ry={1.421}
      />
      <ellipse
        className="dedicated-support-6"
        cx={461.114}
        cy={234.588}
        rx={1.363}
        ry={1.421}
      />
      <ellipse
        className="dedicated-support-6"
        cx={461.114}
        cy={239.136}
        rx={1.363}
        ry={1.421}
      />
      <path
        className="dedicated-support-6"
        d="M292.223 266.041h45.876v5.769h-45.876zM85.299 258.907h167.638v8.64H85.299z"
      />
      <ellipse
        className="dedicated-support-8"
        cx={391.464}
        cy={265.994}
        rx={5.317}
        ry={5.268}
      />
      <ellipse
        className="dedicated-support-6"
        cx={461.114}
        cy={266.921}
        rx={1.363}
        ry={1.421}
      />
      <path
        className="dedicated-support-6"
        d="M484 280.41h-2.727a1.365 1.365 0 1 1 2.727 0Z"
        transform="translate(-21.526 -8.942)"
      />
    </g>
  </svg>
)

export default SvgComponent
